// export const domainUrl="http://90.0.1.48/361/api/";
// export const rootDomainUrl="http://90.0.1.48/demo361/";
// export const rootChatUrl="http://90.0.1.48/361/mchat/";
// export const rootEcoachChatUrl="http://90.0.1.48/361/chat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361_dev";

 // export const domainUrl="http://90.0.1.45/361/api/";
 // export const rootDomainUrl="http://90.0.0.51/imetaproject/";
 // export const rootChatUrl="http://90.0.1.45/361/mchat/";
 // export const rootEcoachChatUrl="http://90.0.1.45/361/chat/";
 // export const onLineUrl="https://www.361online.com/";
 // export const app_name="_361_dev";

//  export const domainUrl="https://www.361dm.com/api/";
//  export const rootDomainUrl="http://90.0.0.51/imetaproject/";
//  export const rootChatUrl="http://localhost/361/mchat/";
//  export const rootEcoachChatUrl="http://localhost/361/chat/";
//  export const onLineUrl="https://www.361online.com/";
//  export const app_name="_361_dev";

// export const domainUrl="http://90.0.0.51/imetaproject/imeta_qa/api/";
// export const rootDomainUrl="http://361dm.com/";
// export const rootChatUrl="http://90.0.0.51/imetaproject/mchat/";
// export const rootEcoachChatUrl="http://90.0.0.51/imetaproject/chat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361_test";

export const domainUrl="https://www.361dm.com/api/";
export const rootDomainUrl="https://www.361dm.com/";
export const rootChatUrl="https://www.361dm.com/rmchat/";
export const rootEcoachChatUrl="https://www.361dm.com/rchat/";
export const onLineUrl="https://www.361online.com/";
export const app_name="_361dm_live";


// export const domainUrl="http://beta.361dm.com/api/";
// export const rootDomainUrl="http://beta.361dm.com/";
// export const rootChatUrl="http://beta.361dm.com/rmchat/";
// export const rootEcoachChatUrl="http://beta.361dm.com/rchat/";
// export const onLineUrl="https://www.361online.com/";
// export const app_name="_361dm_qa";


export const appFullName="361 Minds dm";
export const appImgAlt="361°minds™";
export const routeAfterLogin="learningroom";
export const sessExpire=28800; // eight hours



// WEBPACK FOOTER //
// ./src/config/Config.js